import { render, staticRenderFns } from "./CardBack.vue?vue&type=template&id=ddcb43ce&scoped=true&"
import script from "./CardBack.vue?vue&type=script&lang=js&"
export * from "./CardBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcb43ce",
  null
  
)

export default component.exports